import { CalendarDate } from "@sp-crm/core";
import { READ_ONLY_EMPTY, ReadOnlyField } from "components/ui/read-only-field";
import * as React from "react";

interface ReadOnlyDateFieldProps {
    label: string;
    value: string | null;
}

const formatValue = (value: string | null): string => {
    if (!value) {
        return READ_ONLY_EMPTY;
    }
    const parsed = CalendarDate.parse(value).getOrElse(null);
    return parsed ? parsed.humanFriendly() : READ_ONLY_EMPTY;
};

export const ReadOnlyDateField: React.FC<ReadOnlyDateFieldProps> = ({ label, value }) => (
    <ReadOnlyField label={label} testId="read-only-date-field">
        {formatValue(value)}
    </ReadOnlyField>
);
